<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <div class="title">3天CP {{capacityChinese}}拼团</div>
      <img v-if="groupon_status == 1" class="invite-qrcode" :src="invite_qrcode">
      <!-- <img class="invite-qrcode" src="https://static.huiyiji520.com/cppic-1666347238-dabai.jpg"> -->
      <div v-if="groupon_status == 1" class="invite-hints flex-box">
        <div class="invite-hint">将此页面截图发给好友</div>
        <div class="invite-hint">好友扫码即可参与拼团</div>
      </div>
      <div v-if="groupon_status <= 2" class="members flex-box">
        <span><span v-if="gap > 0">已</span>拼团成员：</span>
        <img v-for="headimg in paid_headimgs" :key="headimg" class="headimg" :src="headimg">
        <span v-if="gap > 0">还差<span class="gap-num"> {{gap}} </span>人</span>
      </div>

      <div v-if="groupon_status == 1 && countdownTime != ''" class="countdown">
        拼团截止时间：<span class="downtime">{{countdownHours}}</span>时<span class="downtime">{{countdownMinutes}}</span>分<span class="downtime">{{countdownSeconds}}</span>秒
      </div>

      <div v-if="groupon_status == 1 && promoter == 1" class="btn-groupon cancel flex-box" @click="cancelGroupon()">取消拼团</div>

      <div v-if="groupon_status == 2 && joined == 1" class="form-hint">拼团已成功，请填写你的报名信息↓</div>

      <div v-if="groupon_status == 2 && joined == 1" class="btn-groupon two flex-box" @click="goForm()">填写报名表</div>

      <div v-if="groupon_status > 2 && joined == 1" class="form-hint">本次拼团已取消</div>

      <div v-if="groupon_status >= 2 && joined == 0" class="form-hint">本次拼团已结束，可继续单人报名↓</div>

      <div v-if="groupon_status >= 2 && joined == 0" class="btn-groupon two flex-box" @click="goForm()">单人报名</div>

    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  data(){
    return {
      groupon_uid: this.$route.params.groupon_uid,
      groupon_status: 99,
      invite_qrcode: "",
      paid_headimgs: [],
      gap: 0,
      capacity: 0,
      capacityChinese: "",
      deadline: 0,
      countdownTime: '',
      countdownHours: 0,
      countdownMinutes: 0,
      countdownSeconds: 0,
      joined: 0,
      promoter: 0
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goForm(){
      let timeLookup = this.$store.state.timeLookup
      let stage = this.$store.state.currentStage
      if(stage == "enrolling" || stage == "matching"){
        this.$router.replace('/choose_me_sex')
      }else if(stage == "matched"){
        // Toast('正在匹配中，当前不可修改～')
        Toast('匹配已结束，当前不可修改～')
      }else{
        Toast('匹配已结束，当前不可修改～')
      }
    },
    getGrouponStatus(){
      let _this = this
      let openid = _this.$store.state.userinfo.openid
      this.$api.get('/groupon/get_groupon_status_by_groupon_uid_v2', {groupon_uid: this.groupon_uid, openid: openid}, res => {
        if(res.code == 200){
          _this.groupon_status = res.groupon_status
          _this.invite_qrcode = res.invite_qrcode
          _this.paid_headimgs = res.paid_headimgs
          _this.gap = res.gap
          _this.capacity = res.capacity
          _this.capacityChinese = ["", "", "双人", "三人"][res.capacity]
          _this.deadline = res.deadline
          _this.joined = res.joined
          _this.promoter = res.promoter
          // _this.getCountDown()
          setInterval(_this.getCountDown, 1000)
        }
      })
    },
    cancelGroupon(){
      let _this = this
      Dialog.confirm({
        title: '提醒',
        message: '取消拼团以后，系统会把已付费用户移出拼团，并发起退款。费用原路退回支付账户。',
        confirmButtonText: '取消拼团',
        cancelButtonText: '再想想'
      })
      .then(() => {
        // on confirm
        // console.log('取消拼团')
        let openid = _this.$store.state.userinfo.openid
        _this.$api.post('/groupon/cancel_groupon', {openid: openid, groupon_uid: _this.groupon_uid}, res => {
          if(res.code == 200){
            Toast('拼团已取消')
            _this.groupon_status = 3
            _this.$store.commit('updatePayStatus', { paid: 0 })
            _this.$store.commit('updatSubmitted', { submitted: 0 })
            _this.$router.replace('/groupon_propose_entry')
          }else if(res.code == 412){
            Toast(res.msg)
          }
        })
      })
      .catch(() => {
        // on cancel
        // console.log('再想想')
      });
    },
    getCountDown(){
      let currentTime = Date.now()
      let futureTime = this.deadline * 1000
      let time = (futureTime - currentTime) / 1000 //把毫秒数变成秒数
      this.countdownHours = parseInt(time / 3600 % 24)// 小时
      this.countdownMinutes = parseInt(time / 60 % 60)// 分钟
      this.countdownSeconds = parseInt(time % 60)//秒
      this.countdownTime =  `${this.countdownHours}时${this.countdownMinutes}分${this.countdownSeconds}秒`
    }
  },
  mounted(){
    this.getGrouponStatus()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background-image: url("https://static.huiyiji520.com/cppic-1661178650.png"); */
  background-image: url("https://static.huiyiji520.com/cppic-1661150074.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .title{margin-top:150px;margin-bottom:80px;font-size:60px;font-weight:500;color:#eb8e80;}
.main .invite-hints{flex-direction: column;margin-top:80px;}
.main .invite-hint{
  font-size:35px;font-weight:bold;margin-bottom:40px;justify-content:center;color:#333;
  background:#E9C5C0;padding:10px 20px;
}
.main .invite-qrcode{margin:0 auto;width:320px;}
.main .members{font-size:28px;justify-content:center;color:#000;}
.main .members .headimg{width:80px;height:80px;border-radius:80px;margin-right:30px;}
.main .members .gap-num{color:#eb8e80;}
.main .countdown{font-size:28px;color:#000;margin-top:25px;}
.main .countdown .downtime{color:#eb8e80;}
.main .form-hint{font-size:28px;color:#000;margin-top:25px;}
.main .btn-groupon{
  width:350px;height:90px;font-size:30px;border:2px solid black;
  margin:0px auto;justify-content:center;margin-bottom:50px;margin-top:60px;color:#000;
  background:#fff;
}
.main .btn-groupon.cancel{font-size:26px;width:200px;height:60px;}
</style>
